import React from "react";

// ui
import { CustomInput } from "reactstrap";

const Radio = (props) => {
	// console.log(JSON.stringify(props));
	// console.log(props);
	const {
		name,
		label,
		radioValue,
		value,
		valid,
		invalid,
		checked,
		...attributes
	} = props;

	const inputId = `radio-${name.replace(/\./g, "-")}-${radioValue}`;

	return (
		<div>
			<CustomInput
				name={name}
				label={label}
				type="radio"
				id={inputId}
				value={radioValue}
				valid={valid}
				invalid={invalid}
				{...attributes}
			/>
		</div>
	);
};

Radio.defaultProps = {
	invalid: undefined,
	valid: undefined,
};

export default Radio;
